export default {
  install(app, options) {
    app.config.globalProperties.EDRONE_CONTEXT = window.EDRONE_CONTEXT;
    app.provide("edroneContext", options);
  },
};
